export class MobileControls {
  constructor(game) {
    this.game = game;
  }

  _setupMobileControls() {
    const leftZone = document.getElementById('mobile-left-zone');
    const rightZone = document.getElementById('mobile-right-zone');
    const joystick = document.getElementById('mobile-joystick');
    const lookJoystick = document.getElementById('mobile-look-joystick');
    const actionBtn = document.getElementById('mobile-action-btn');
    const jumpBtn = document.getElementById('mobile-jump-btn');

    this.game.input.bindVirtualButton('Action', actionBtn);
    this.game.input.bindVirtualButton('Space', jumpBtn);

    if (!joystick || !lookJoystick || !leftZone || !rightZone) return;

    let leftPointerId = null;
    let leftCenter = { x: 0, y: 0 };
    let rightPointerId = null;
    let rightCenter = { x: 0, y: 0 };
    const leftKnob = joystick.querySelector('.joystick-knob');
    const rightKnob = lookJoystick.querySelector('.joystick-knob');
    const joystickSize = 120;
    const knobRadius = 42;

    const showJoystick = (container, x, y) => {
      container.style.left = `${x - joystickSize / 2}px`;
      container.style.top = `${y - joystickSize / 2}px`;
      container.style.display = 'block';
    };

    const hideJoystick = (container) => {
      container.style.display = 'none';
      const knob = container.querySelector('.joystick-knob');
      if (knob) knob.style.transform = 'translate(-50%, -50%)';
    };

    const setJoystickKeys = (up, down, left, right) => {
      const setKey = (code, enabled) => {
        if (enabled) this.game.input.keys.add(code);
        else this.game.input.keys.delete(code);
      };
      setKey('ArrowUp', up);
      setKey('ArrowDown', down);
      setKey('ArrowLeft', left);
      setKey('ArrowRight', right);
    };

    const clearLeft = () => {
      leftPointerId = null;
      hideJoystick(joystick);
      setJoystickKeys(false, false, false, false);
    };

    const clearRight = () => {
      rightPointerId = null;
      hideJoystick(lookJoystick);
      this.game.input.clearTouchLookVector();
    };

    const updateLeft = (clientX, clientY) => {
      const dx = clientX - leftCenter.x;
      const dy = clientY - leftCenter.y;
      const dist = Math.sqrt(dx * dx + dy * dy);
      const moveDeadzone = 10;

      if (dist > moveDeadzone && joystick.style.display === 'none') {
        showJoystick(joystick, leftCenter.x, leftCenter.y);
      }

      const clampedX = Math.max(-knobRadius, Math.min(knobRadius, dx));
      const clampedY = Math.max(-knobRadius, Math.min(knobRadius, dy));
      if (leftKnob) leftKnob.style.transform = `translate(calc(-50% + ${clampedX}px), calc(-50% + ${clampedY}px))`;
      const nx = clampedX / knobRadius;
      const ny = clampedY / knobRadius;
      setJoystickKeys(ny < -0.3, ny > 0.3, nx < -0.3, nx > 0.3);
    };

    const updateRight = (clientX, clientY) => {
      const dx = clientX - rightCenter.x;
      const dy = clientY - rightCenter.y;
      const dist = Math.sqrt(dx * dx + dy * dy);
      const lookDeadzone = 10;

      if (dist > lookDeadzone && lookJoystick.style.display === 'none') {
        showJoystick(lookJoystick, rightCenter.x, rightCenter.y);
      }

      const clampedX = Math.max(-knobRadius, Math.min(knobRadius, dx));
      const clampedY = Math.max(-knobRadius, Math.min(knobRadius, dy));
      if (rightKnob) rightKnob.style.transform = `translate(calc(-50% + ${clampedX}px), calc(-50% + ${clampedY}px))`;

      const lookStrength = 0.1;
      const normalize = (value) => {
        if (Math.abs(value) <= lookDeadzone) return 0;
        const sign = Math.sign(value);
        return sign * Math.min(1, (Math.abs(value) - lookDeadzone) / (knobRadius - lookDeadzone));
      };
      const nx = normalize(clampedX);
      const ny = normalize(clampedY);
      this.game.input.setTouchLookVector(nx * knobRadius * lookStrength, ny * knobRadius * lookStrength);
    };

    const startLeftTouch = (touch) => {
      leftPointerId = touch.identifier;
      leftCenter = { x: touch.clientX, y: touch.clientY };
      updateLeft(touch.clientX, touch.clientY);
    };

    const startRightTouch = (touch) => {
      rightPointerId = touch.identifier;
      rightCenter = { x: touch.clientX, y: touch.clientY };
      updateRight(touch.clientX, touch.clientY);
    };

    leftZone.addEventListener('touchstart', (e) => {
      if (leftPointerId !== null) return;
      for (const touch of e.changedTouches) {
        startLeftTouch(touch);
        // e.preventDefault();
        break;
      }
    }, { passive: true });

    // Handle touchmove on window to allow dragging while holding buttons
    window.addEventListener('touchmove', (e) => {
      // Handle Left Joystick
      if (leftPointerId !== null) {
        for (const touch of e.changedTouches) {
          if (touch.identifier === leftPointerId) {
            updateLeft(touch.clientX, touch.clientY);
            if (e.cancelable) e.preventDefault();
          }
        }
      }

      // Handle Right Joystick (Look)
      if (rightPointerId !== null) {
        for (const touch of e.changedTouches) {
          if (touch.identifier === rightPointerId) {
            updateRight(touch.clientX, touch.clientY);
            if (e.cancelable) e.preventDefault();
          }
        }
      }
    }, { passive: false });

    const onLeftTouchEnd = (e) => {
      if (leftPointerId === null) return;
      for (const touch of e.changedTouches) {
        if (touch.identifier !== leftPointerId) continue;
        clearLeft();
        // e.preventDefault();
        break;
      }
    };

    leftZone.addEventListener('touchend', onLeftTouchEnd, { passive: true });
    leftZone.addEventListener('touchcancel', onLeftTouchEnd, { passive: true });

    rightZone.addEventListener('touchstart', (e) => {
      if (rightPointerId !== null) return;
      for (const touch of e.changedTouches) {
        startRightTouch(touch);
        // e.preventDefault();
        break;
      }
    }, { passive: true });

    // Use window for end too to be safe
    const onRightTouchEnd = (e) => {
      if (rightPointerId === null) return;
      for (const touch of e.changedTouches) {
        if (touch.identifier !== rightPointerId) continue;
        clearRight();
        // e.preventDefault();
        break;
      }
    };

    window.addEventListener('touchend', (e) => {
      onLeftTouchEnd(e);
      onRightTouchEnd(e);
    }, { passive: true });
    window.addEventListener('touchcancel', (e) => {
      onLeftTouchEnd(e);
      onRightTouchEnd(e);
    }, { passive: true });

    const startActionTouch = (e) => {
      // If we don't have a right pointer yet, this touch on the button can become it
      if (rightPointerId === null) {
        for (const touch of e.changedTouches) {
          startRightTouch(touch);
          break;
        }
      }
    };

    actionBtn.addEventListener('touchstart', startActionTouch, { passive: true });
    jumpBtn.addEventListener('touchstart', startActionTouch, { passive: true });
  }
}
